import { getGlobalVariables, useBehavior } from '@libs/core';
import { TWidgetProps } from '@libs/types';
import React from 'react';
import { TZendeskChat } from '../../types/data';
import { TButtonOption } from '../../types/options';
import { ZendeskChatView } from './ZendeskChatView';

/**
 * For this widget we should set the Global variable in .env file with URL of chat script
 *  example: NX_PUBLIC_GLOBAL_zendeskChatApiKey='https://static.zdassets.com/ekr/snippet.js?key=561d898d-1496-4cd1-9e'
 */
export const ZendeskChat = ({ widget }: TWidgetProps<TZendeskChat, TButtonOption>) => {
    const label = widget.data?.messages?.label ?? widget.data?.label;
    const { iconName = 'ic_life_buoy', margin } = widget.options ?? {};
    const { zendeskToken, extras, conversationId } = widget.data ?? {};

    const { zendeskChatApiKey } = getGlobalVariables('zendeskChatApiKey');
    const { isDisabled, isHidden } = useBehavior(widget);
    const parentStyleNames = [widget.options?.style ?? ' '].filter(Boolean) as string[];

    return (
        <ZendeskChatView
            uid={widget.uid}
            widget={widget}
            isDisabled={isDisabled}
            isHide={isHidden}
            label={label}
            iconName={iconName}
            parentStyleNames={parentStyleNames}
            margin={margin}
            isFloatButton={false}
            zendeskChatApiKey={zendeskChatApiKey}
            zendeskToken={zendeskToken}
            extras={extras}
            conversationId={conversationId}
        />
    );
};
